module.exports = __webpack_public_path__ + "img/MoFoto.cbf6952d.jpg";